import {Component, OnInit} from '@angular/core';
import {SystemStatus} from "../system-status/system-status";
import {SystemStatusPollerService} from "../system-status/system-status-poller.service";
import {distinctUntilChanged, filter, map, pairwise} from "rxjs/operators";
import {logAsync} from "../../../../helpers/logging";

@Component({
  selector: 'app-system-upgrade-screen',
  templateUrl: './system-upgrade-screen.component.html',
  styleUrls: ['./system-upgrade-screen.component.scss']
})
export class SystemUpgradeScreenComponent implements OnInit {
  public showUpgradeScreen = false;

  private readonly upgradeInProgress$ = this.status.changes$.pipe(
      map(({upgradeInProgress}) => upgradeInProgress),
      distinctUntilChanged(),
  );
  private readonly wasUpgraded = this.upgradeInProgress$.pipe(
      pairwise(),
      filter(([previous, current]) => previous === true && current === false),
      logAsync('Application upgrade installed. Reloading …')
  );

  constructor(
      public readonly status: SystemStatus,
      private readonly polling: SystemStatusPollerService,
  ) {
  }

  ngOnInit(): void {
    this.status.changes$.subscribe(({upgradeInProgress}) => this.showUpgradeScreen = upgradeInProgress);
    this.wasUpgraded.subscribe(() => window.location.reload());
  }

}
